<div class="block-text-img">
  <div class="container">
    <div [ngClass]="'row align-items-center container-block-text mb-reverse ' + (left ? 'left' : '')">
      <div class="block-text col-12 col-md-6 col-lg-6 col-xl-6">
        <ng-content select="[contentText]"></ng-content>
      </div>
      <div
        [ngClass]="
          'col-12 col-md-6 col-lg-6 col-xl-6 block-img text-center ' +
          (left ? 'animation-left' : 'animation-right')
        "
      >
        <ng-content select="[contentImg]"></ng-content>
      </div>
    </div>
  </div>
</div>